<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" :style="`background-image: url('/assets/images/pages/login-bg_${appFilename}.jpg')`">
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img src="@/assets/images/pages/register.jpg" alt="register" class="mx-auto" />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg" v-if="!awaiting_auth_code">
              <div class="p-8">
                <div class="vx-card__title">
                  <h4 class="mb-4">Criar uma Conta</h4>
                </div>
                <div class="clearfix">
                  <form @submit="requestAuthCodeSubmit">
                    <vs-input
                      v-validate="'required|email'"
                      data-vv-validate-on="blur"
                      name="email"
                      type="email"
                      label-placeholder="Email"
                      placeholder="Email"
                      v-model.trim="email"
                      class="w-full mt-6"
                      autocomplete="email"
                    />
                    <div class="my-6">&nbsp;</div>
                    <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                    <vs-button type="border" to="/pages/login" class="mt-6">Login</vs-button>
                    <vs-button class="float-right mt-6" @click="requestAuthCode">Continuar</vs-button>
                    <button type="submit" style="display: none"></button>
                  </form>
                </div>
              </div>
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg" v-if="awaiting_auth_code">
              <div class="p-8">
                <div class="vx-card__title">
                  <h4 class="mb-4">Digite o código que foi enviado para o seu e-mail</h4>
                </div>
                <div class="clearfix">
                  <form @submit="validateAuthCodeSubmit">
                    <vs-input
                      v-validate="'required'"
                      data-vv-validate-on="blur"
                      name="authCode"
                      type="authCode"
                      label-placeholder="Código de Autenticação"
                      placeholder="Código de Autenticação"
                      v-model.trim="authCode"
                      class="w-full mt-6"
                      autocomplete="username"
                    />
                    <div class="my-6">&nbsp;</div>
                    <span class="text-danger text-sm">{{ errors.first('authCode') }}</span>

                    <vs-button type="border" @click="awaiting_auth_code = false" class="mt-6">Voltar</vs-button>
                    <vs-button class="float-right mt-6" @click="validateAuthCode">Continuar</vs-button>
                    <button type="submit" style="display: none"></button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";

export default {
  data() {
    return {
      email: "",
      authCode: "",
      appName: process.env.VUE_APP_NAME,
      appFilename: process.env.VUE_APP_FILENAME,
      awaiting_auth_code: false,
    };
  },
  mounted() {
    if (this.$route.query.aff) {
      localStorage.setItem('aff', this.$route.query.aff)
    }
  },
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.email !== ""
      );
    }
  },
  methods: {
    requestAuthCode() {
      if (!this.validateForm) return false;

      this.$api
        .post("/api/v1/affiliate/auth/request-auth-code", {
          email: this.email,
          affiliate: localStorage.getItem('aff') || null
        })
        .then(() => {
          this.$vs.notify({
            time: 6000,
            text: "Verifique o código que foi enviado ao seu e-mail",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });

          this.awaiting_auth_code = true
        })
        .catch(error => {
          this.$vs.notify({
            time: 6000,
            text: error.response.data.errors.join("<br>"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    },
    requestAuthCodeSubmit(e) {
      this.requestAuthCode();
      e.preventDefault();
    },
    validateAuthCode() {
      this.$api
        .post("/api/v1/affiliate/auth/validate-auth-code", {
          email: this.email,
          authCode: this.authCode
        })
        .then((response) => {
          this.$vs.notify({
            time: 6000,
            text: "Sua conta foi criada com sucesso.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success"
          });

          if (response.data.access_token) {
            localStorage.setItem('user', JSON.stringify(response.data));

            Vue.prototype.$api = axios.create({
              headers: {
                Authorization: `Bearer ${response.data.access_token}`
              }
            });

            this.$router.push('/').catch(() => {
            });
          }
        })
        .catch(error => {
          this.$vs.notify({
            time: 6000,
            text: error.response.data.errors.join("<br>"),
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger"
          });
        });
    },
    validateAuthCodeSubmit(e) {
      this.validateAuthCode();
      e.preventDefault();
    },
  }
};
</script>
